const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
const waitFor = async (selector) => {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);

    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const nodes = [...mutation.addedNodes];
        for (const node of nodes) {
          if (node.matches && node.matches(selector)) {
            observer.disconnect();
            resolve(node);
            return;
          }
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
};
window.waitFor = waitFor;

window.productsSlickSettings = {
  slidesToShow: 5,
  infinite: false,
  dots: true,
  responsive: [
    {
      breakpoint: 1171,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 890,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
window.mmLanguage = dataLayer[0].shoptet.language;

// const handleHeader = async () => {
//   // const navigation = document.querySelector('#navigation')
//   // const siteNameWrapper = document.querySelector('.site-name-wrapper')
//   // if (navigation && siteNameWrapper) siteNameWrapper.after(navigation)
//   // const menuHelper = document.querySelector('.menu-helper')
//   // if (menuHelper && navigation) navigation.parentElement.insertBefore(menuHelper, navigation.nextElementSibling)
//   const navigationButtons = document.querySelector(".navigation-buttons");
//   const loginButton =
//     document.querySelector(".top-nav-button-account") ||
//     document.querySelector(".top-nav-button-login");
//   if (navigationButtons && loginButton) navigationButtons.prepend(loginButton);
//   const searchButton = document.querySelector(
//     '.toggle-window[data-target="search"]'
//   );
//   if (navigationButtons && searchButton)
//     navigationButtons.prepend(searchButton);
//   const menuTrigger = document.querySelector(
//     '.toggle-window[data-target="navigation"]'
//   );
//   if (menuTrigger && navigationButtons)
//     navigationButtons.appendChild(menuTrigger);
//   const topNavigationBar = document.querySelector(".top-navigation-bar");
//   const siteHeader = document.querySelector("#header");
//   const navigationIn = document.querySelector(".navigation-in");
//   if (topNavigationBar) {
//     if (window.innerWidth >= 768) {
//       if (topNavigationBar.nextElementSibling !== siteHeader) {
//         siteHeader.parentElement.insertBefore(topNavigationBar, siteHeader);
//       }
//     } else {
//       if (topNavigationBar.parentElement !== navigationIn) {
//         navigationIn.appendChild(topNavigationBar);
//       }
//     }
//     document.addEventListener("resizeEnd", () => {
//       if (window.innerWidth >= 768) {
//         if (topNavigationBar.nextElementSibling !== siteHeader) {
//           siteHeader.parentElement.insertBefore(topNavigationBar, siteHeader);
//         }
//       } else {
//         if (topNavigationBar.parentElement !== navigationIn) {
//           navigationIn.appendChild(topNavigationBar);
//         }
//       }
//     });
//   }

//   // if (window.innerWidth >= 767) {
//   const menuLvl2s = document.querySelectorAll("#navigation .menu-level-2");
//   menuLvl2s.forEach((menuLvl2) => {
//     const helper = document.createElement("div");
//     helper.classList.add("menu-level-2-helper");
//     menuLvl2.parentElement.insertBefore(helper, menuLvl2);
//     helper.appendChild(menuLvl2);
//     const menuLvl2Images = menuLvl2.querySelectorAll("li .menu-image img");
//     menuLvl2Images.forEach((img) => {
//       const imgSrc = img.getAttribute("src");
//       const imgDataSrc = img.getAttribute("data-src");
//       if (imgSrc !== imgDataSrc && imgDataSrc) img.src = imgDataSrc;
//     });
//   });
//   // }
//   // const menuBanner = document.querySelector(".custom-footer__banner7");
//   // if (menuBanner) {
//   //   // if (window.innerWidth >= 768) {
//   //   const menuLvl2helpers = document.querySelectorAll(".menu-level-2-helper");
//   //   menuLvl2helpers.forEach((helper) => {
//   //     const bannerClone = menuBanner.cloneNode(true);
//   //     const bannerCloneImg = bannerClone.querySelector("img");
//   //     const imgSrc = bannerCloneImg.getAttribute("src");
//   //     const imgDataSrc = bannerCloneImg.getAttribute("data-src");
//   //     if (imgSrc !== imgDataSrc && imgDataSrc) bannerCloneImg.src = imgDataSrc;
//   //     helper.appendChild(bannerClone);
//   //   });
//   //   menuBanner.remove();
//   //   // } else {
//   //   // 	const navigation = document.querySelector('#navigation')
//   //   // 	if (navigation) {
//   //   // 		navigation.appendChild(menuBanner)
//   //   // 	} else {
//   //   // 		menuBanner.remove()
//   //   // 	}
//   //   // }
//   // }
//   // const menuLvL2Li = document.querySelectorAll('.menu-level-2 > li')
//   // menuLvL2Li.forEach((li) => {
//   // 	const innerImg = li.querySelector('.menu-image > img')
//   // 	const toRemove = li.querySelector('.menu-image')
//   // 	const targetA = li.querySelector('div > a')
//   // 	if (innerImg && toRemove) {
//   // 		if (innerImg.getAttribute('data-src'))
//   // 			innerImg.setAttribute('data-src', innerImg.getAttribute('data-src').replace('/thumb/', '/orig/'))
//   // 		if (innerImg.getAttribute('src')) innerImg.setAttribute('src', innerImg.getAttribute('src').replace('/thumb/', '/orig/'))
//   // 		const imgWrap = document.createElement('div')
//   // 		imgWrap.classList.add('menu-image')
//   // 		imgWrap.appendChild(innerImg)
//   // 		targetA.prepend(imgWrap)
//   // 		toRemove.remove()
//   // 	}
//   // })

//   let initialYScroll = 0;
//   const debouncedScroll = debounce(function () {
//     const header = document.querySelector("#header");
//     const headerOffsetTop = header.offsetTop;
//     const windowScrollTop = window.scrollY;
//     if (headerOffsetTop - 1 <= windowScrollTop) {
//       header.classList.add("sticky");
//       console.log(headerOffsetTop, windowScrollTop);
//     } else {
//       header.classList.remove("sticky");
//       console.log(headerOffsetTop, windowScrollTop);
//     }
//     if (windowScrollTop > initialYScroll) {
//       header.classList.remove("scroll-up");
//       header.classList.add("scroll-down");
//     } else {
//       header.classList.remove("scroll-down");
//       header.classList.add("scroll-up");
//     }
//     initialYScroll = windowScrollTop;
//   }, 100);

//   window.addEventListener("scroll", debouncedScroll);

//   const headerTop = document.querySelector("#header .header-top");
//   const search = document.querySelector(".header-top .search");
//   const siteMessage = document.querySelector(".site-msg.information") || 0;
//   if (headerTop) {
//     if (window.innerWidth <= 767) {
//       console.log(
//         headerTop.clientHeight,
//         search.clientHeight,
//         siteMessage ? siteMessage.clientHeight : 0
//       );
//       header.style.setProperty(
//         "--header-top-height",
//         `${
//           headerTop.clientHeight + (siteMessage ? siteMessage.clientHeight : 0)
//         }px`
//       );
//     } else {
//       header.style.setProperty(
//         "--header-top-height",
//         `${headerTop.clientHeight}px`
//       );
//     }
//   }
// };
// handleHeader();

const navigationButtons = document.querySelector(
  ".header-top .navigation-buttons"
);
const topNavBarContainer = document.querySelector(
  ".top-navigation-bar > .container"
);
const navigationIn = document.querySelector(".navigation-in");
const headerTop = document.querySelector(".header-top");
const handleHeader = () => {
  // NAVIGATION
  const allCategoriesButton = document.createElement("div");
  const allCategoriesButtonText = document.createElement("span");
  const categoriesDropdown = document.createElement("div");
  allCategoriesButton.classList.add("all-categories");
  allCategoriesButton.appendChild(allCategoriesButtonText);
  categoriesDropdown.classList.add("categories-dropdown");
  allCategoriesButton.appendChild(categoriesDropdown);
  allCategoriesButtonText.innerHTML = "Produkty";
  allCategoriesButtonText.classList.add("all-categories-trigger");
  const menuLevel1 = document.querySelector("#navigation .menu-level-1");
  if (menuLevel1) categoriesDropdown.appendChild(menuLevel1);
  if (navigationIn) navigationIn.appendChild(allCategoriesButton);
  if (window.innerWidth <= 767) {
    allCategoriesButtonText.addEventListener("click", () => {
      categoriesDropdown.style.display =
        categoriesDropdown.style.display === "block" ? "none" : "block";
    });
    // const valueLang = document.querySelector(
    //   ".top-navigation-tools.top-navigation-tools--language"
    // );
    // if (valueLang) navigationIn.prepend(valueLang);
  }

  // HEADER TOP
  const topNavMenu = document.querySelector(".top-navigation-menu");
  if (topNavMenu && navigationIn) navigationIn.appendChild(topNavMenu);
  const navigationButtons = document.querySelector(".navigation-buttons");
  const loginButton =
    document.querySelector(".top-nav-button-account") ||
    document.querySelector(".top-nav-button-login");
  if (navigationButtons && loginButton) navigationButtons.prepend(loginButton);
  const searchButton = document.querySelector(
    '.toggle-window[data-target="search"]'
  );

  if (navigationButtons && searchButton)
    navigationButtons.prepend(searchButton);
  const menuTrigger = document.querySelector(
    '.toggle-window[data-target="navigation"]'
  );
  if (menuTrigger && navigationButtons)
    navigationButtons.appendChild(menuTrigger);
  const headerLinks = document.querySelector(".custom-footer__banner10 ");
  if (headerLinks) {
    navigationIn.appendChild(headerLinks);
  }
  // const headerSiteContacts = document.querySelector(
  //   ".top-navigation-bar .top-navigation-contacts"
  // );
  // if (headerSiteContacts && navigationButtons)
  //   navigationButtons.parentElement.insertBefore(
  //     headerSiteContacts,
  //     navigationButtons
  //   );
  // const registerLoginMenu = document.createElement("div");
  // registerLoginMenu.classList.add(
  //   "top-navigation-bar-menu",
  //   "register-login-menu"
  // );
  // if (topNavBarContainer) topNavBarContainer.appendChild(registerLoginMenu);
  // const loginAccountButton =
  //   document.querySelector(".top-nav-button-login") ||
  //   document.querySelector(".top-nav-button-account");
  // if (loginAccountButton) {
  //   if (window.innerWidth <= 767) {
  //     navigationButtons.prepend(loginAccountButton);
  //   } else {
  //     registerLoginMenu.appendChild(loginAccountButton);
  //   }
  //   document.addEventListener("resizeEnd", () => {
  //     if (window.innerWidth <= 767) {
  //       navigationButtons.prepend(loginAccountButton);
  //     } else {
  //       registerLoginMenu.appendChild(loginAccountButton);
  //     }
  //   });
  // }

  // const registerButton = document.createElement("a");
  // registerButton.classList.add("top-nav-button", "top-nav-button-register");
  // registerButton.href = "/registrace/";
  // registerButton.innerText = "Registrace";
  // registerLoginMenu.appendChild(registerButton);

  const headerTopMenuCustom = document.querySelector(
    ".custom-footer__section3"
  );
  if (headerTopMenuCustom) {
    headerTopMenuCustom.classList.add("top-navigation-bar-menu");
    if (topNavBarContainer) topNavBarContainer.prepend(headerTopMenuCustom);
  }

  const navigationToggle = document.querySelector(
    '.responsive-tools .toggle-window[data-target="navigation"]'
  );
  if (navigationToggle) headerTop.prepend(navigationToggle);
};
handleHeader();
const handleUSP = async () => {
  let benefitBanner = document.querySelector(".benefitBanner");
  if (benefitBanner) {
    const benefitCookie = window.sessionStorage.getItem("benefitBanner");
    if (!benefitCookie)
      window.sessionStorage.setItem("benefitBanner", benefitBanner.innerHTML);
  } else {
    let benefitCookie = window.sessionStorage.getItem("benefitBanner");
    if (!benefitCookie) {
      try {
        const response = await fetch("/");
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        benefitBanner = doc.querySelector(".benefitBanner");
        if (benefitBanner) {
          benefitCookie = benefitBanner.innerHTML;
          window.sessionStorage.setItem(
            "benefitBanner",
            benefitBanner.innerHTML
          );
        }
      } catch (e) {
        console.error(e);
      }
    }
    benefitBanner = document.createElement("div");
    benefitBanner.classList.add("benefitBanner");
    benefitBanner.innerHTML = benefitCookie;
  }
  // const pageFooter = document.querySelector('#footer')
  // if (pageFooter) pageFooter.parentElement.insertBefore(benefitBanner, pageFooter)
};
handleUSP();

const handleCategory = async (reload = false) => {
  const categoryTopDuplicate = document.querySelector(".category-top-wrapper");
  const categoryTitleDuplicate = document.querySelector(
    "#content .category-title"
  );
  const categoryTop = document.querySelector("#content .category-top");
  const categoryContentWrapper = document.querySelector("#content-wrapper");
  const subcategories = document.querySelector("#content .subcategories");
  // // const categoryUSP = document.querySelector('.benefitBanner')
  if (categoryTopDuplicate) {
    if (categoryTop) categoryTop.remove();
    if (subcategories) subcategories.remove();
    if (categoryTitleDuplicate) categoryTitleDuplicate.remove();
  } else {
    const categoryTopWrapper = document.createElement("div");
    categoryTopWrapper.classList.add("category-top-wrapper");
    categoryContentWrapper.parentElement.insertBefore(
      categoryTopWrapper,
      categoryContentWrapper
    );
    const categoryTopContainer = document.createElement("div");
    categoryTopContainer.classList.add("container", "category-top-content");
    categoryTopWrapper.appendChild(categoryTopContainer);
    const categoryTitle = document.querySelector(".category-title");
    const categoryPerex = document.querySelector(
      ".category-perex:not(.empty-content)"
    );
    if (categoryTitle) categoryTopContainer.appendChild(categoryTitle);

    if (categoryPerex) {
      const allParagraphs = categoryPerex.querySelectorAll("p");
      allParagraphs.forEach((p) => {
        if (p.innerText.trim() === "#SHOW_MORE#") {
          p.innerHTML = "";
          const showMoreButton = document.createElement("button");
          showMoreButton.classList.add("show-more", "btn", "btn-secondary");
          showMoreButton.innerHTML = "Více informací";
          showMoreButton.setAttribute(
            "data-alternative-text",
            "Méně informací"
          );
          p.appendChild(showMoreButton);
          categoryPerex.classList.add("show-more");
          showMoreButton.addEventListener("click", () => {
            categoryPerex.classList.toggle("show-more");
            const help = showMoreButton.getAttribute("data-alternative-text");
            showMoreButton.setAttribute(
              "data-alternative-text",
              showMoreButton.innerText
            );
            showMoreButton.innerText = help;
          });
        }
      });
      categoryTopContainer.appendChild(categoryPerex);
    }

    const breadcrumbsWrapper = document.querySelector(".breadcrumbs-wrapper");
    if (breadcrumbsWrapper) categoryTopWrapper.prepend(breadcrumbsWrapper);
    if (subcategories)
      categoryContentWrapper.parentElement.insertBefore(
        subcategories,
        categoryContentWrapper
      );
    // categoryTopContainer.appendChild(categoryTop)
    // 	// if (categoryTop && subcategories) categoryTop.parentElement.insertBefore(subcategories, categoryTop.nextElementSibling)
    // 	const categoryImage = categoryTop.querySelector('p > img') || categoryTop.querySelector('p > span > img')
    // 	const imageWrapper = document.createElement('div')
    // 	imageWrapper.classList.add('category-image')
    // 	if (categoryImage) {
    // 		const toRemove = categoryImage.closest('p')
    // 		imageWrapper.appendChild(categoryImage)
    // 		toRemove.remove()
    // 	} else {
    // 		const categoryVideo = document.querySelector('p > video')
    // 		if (categoryVideo) {
    // 			const toRemove = categoryVideo.closest('p')
    // 			imageWrapper.appendChild(categoryVideo)
    // 			categoryVideo.removeAttribute('controls')
    // 			categoryVideo.setAttribute('preload', 'auto')
    // 			// categoryVideo.width = '454'
    // 			// categoryVideo.height = '278'
    // 			toRemove.remove()
    // 			const playVideoButton = document.createElement('button')
    // 			playVideoButton.classList.add('play-video')
    // 			playVideoButton.innerHTML = `<img src="https://cdn.myshoptet.com/usr/343520.myshoptet.com/user/documents/projects/worksafety/assets/img/play-video.png" alt="Přehrát video" width="167" height="124" />`
    // 			imageWrapper.appendChild(playVideoButton)
    // 			playVideoButton.addEventListener('click', () => {
    // 				categoryVideo.play()
    // 				playVideoButton.remove()
    // 				categoryVideo.setAttribute('controls', '')
    // 			})
    // 		}
    // 	}
    // 	categoryTop.prepend(imageWrapper)
    // 	const categoryTopBG = document.querySelector('#data-background')
    // 	if (categoryTopBG) {
    // 		categoryTopContainer.style.backgroundColor = categoryTopBG.getAttribute('data-background')
    // 		categoryTopBG.remove()
    // 	}
  }
  // if (categoryUSP) {
  // 	const subcategoriesHelp = document.querySelector('.subcategories')
  // 	const categoryTopHelp = document.querySelector('.category-top')
  // 	if (subcategoriesHelp) {
  // 		subcategoriesHelp.parentElement.insertBefore(categoryUSP, subcategoriesHelp.nextElementSibling)
  // 	} else if (categoryTopHelp) {
  // 		categoryTopHelp.parentElement.insertBefore(categoryUSP, categoryTopHelp.nextElementSibling)
  // 	}
  // }
  // const categoryTopWrapper = document.querySelector(".category-top-wrapper");
  // if (!reload) {
  // const setBackground = (desktopImg, mobileImg) => {
  // 	let desktop = desktopImg
  // 	let mobile = mobileImg
  // 	if (!desktop) desktop = mobileImg
  // 	if (!mobile) mobile = desktopImg
  // 	if (categoryTopWrapper) {
  // 		categoryTopWrapper.classList.add('has-background')
  // 		// categoryTopWrapper.style.backgroundImage = window.innerWidth > 767 ? `url(${desktopImg})` : `url(${mobileImg})`
  // 		categoryTopWrapper.setAttribute('data-desktop', desktop)
  // 		categoryTopWrapper.setAttribute('data-mobile', mobile)
  // 	}
  // }
  // const categoryBG = document.querySelectorAll(
  //   ".category__secondDescription > p img"
  // );
  // if (categoryBG.length) {
  //   let desktopImg;
  //   let mobileImg;
  //   let otherImages = [];
  //   let otherImagesDesktop = [];
  //   let otherImagesMobile = [];
  //   let imagesLoading = [];
  //   categoryBG.forEach((img) => {
  //     imagesLoading.push(
  //       new Promise((resolve) => {
  //         if (img.complete) {
  //           if (img.naturalWidth > 1900) {
  //             desktopImg = img;
  //           } else if (img.naturalWidth <= 1900 && img.naturalWidth >= 767) {
  //             mobileImg = img;
  //           } else if (img.naturalWidth < 767 && img.naturalWidth > 500) {
  //             otherImagesDesktop.push(img);
  //           } else if (img.naturalWidth <= 500) {
  //             otherImagesMobile.push(img);
  //           } else {
  //             otherImages.push(img);
  //           }
  //           img.closest("p").remove();
  //           resolve();
  //         } else {
  //           img.addEventListener("load", () => {
  //             if (img.naturalWidth > 1900) {
  //               desktopImg = img;
  //             } else if (
  //               img.naturalWidth <= 1900 &&
  //               img.naturalWidth >= 767
  //             ) {
  //               mobileImg = img;
  //             } else if (img.naturalWidth < 767 && img.naturalWidth > 500) {
  //               otherImagesDesktop.push(img);
  //             } else if (img.naturalWidth <= 500) {
  //               otherImagesMobile.push(img);
  //             } else {
  //               otherImages.push(img);
  //             }
  //             img.closest("p").remove();
  //             resolve();
  //           });
  //         }
  //       })
  //     );
  //   });
  //   Promise.all(imagesLoading)
  //     .then(() => {
  //       // setBackground(desktopImg, mobileImg)
  //       if (desktopImg) {
  //         desktopImg.classList.add("desktop", "background-image");
  //         categoryTopWrapper.appendChild(desktopImg);
  //         categoryTopWrapper.classList.add("has-background");
  //       }
  //       if (mobileImg) {
  //         mobileImg.classList.add("mobile", "background-image");
  //         categoryTopWrapper.appendChild(mobileImg);
  //         categoryTopWrapper.classList.add("has-background");
  //       }
  //       if (otherImagesDesktop.length) {
  //         const categoryTopContainer = document.querySelector(
  //           ".category-top-wrapper > .category-top-content"
  //         );
  //         if (categoryTopContainer) {
  //           const categoryImages = document.createElement("div");
  //           categoryImages.classList.add("category-images", "desktop");
  //           categoryTopContainer.appendChild(categoryImages);
  //           otherImagesDesktop.forEach((img) => {
  //             const otherImageLink = img.closest("a");
  //             if (otherImageLink) {
  //               categoryImages.appendChild(otherImageLink);
  //             } else {
  //               categoryImages.appendChild(img);
  //             }
  //           });
  //           $(categoryImages).slick({
  //             slidesToShow: 1,
  //             arrows: true,
  //             dots: true,
  //             autoplay: true,
  //             autoplaySpeed: 5000,
  //           });
  //         }
  //       }
  //       if (otherImagesMobile.length) {
  //         const categoryTopContainer = document.querySelector(
  //           ".category-top-wrapper > .category-top-content"
  //         );
  //         if (categoryTopContainer) {
  //           const categoryImages = document.createElement("div");
  //           categoryImages.classList.add("category-images", "mobile");
  //           categoryTopContainer.appendChild(categoryImages);
  //           otherImagesMobile.forEach((img) => {
  //             const otherImageLink = img.closest("a");
  //             if (otherImageLink) {
  //               categoryImages.appendChild(otherImageLink);
  //             } else {
  //               categoryImages.appendChild(img);
  //             }
  //           });
  //           $(categoryImages).slick({
  //             slidesToShow: 1,
  //             arrows: true,
  //             dots: true,
  //             autoplay: true,
  //             autoplaySpeed: 5000,
  //           });
  //         }
  //       }
  //       if (otherImages.length) {
  //         // const categoryTopContainer = document.querySelector('.category-top-wrapper > .category-top-content')
  //         // if (categoryTopContainer) {
  //         // 	const categoryImages = document.createElement('div')
  //         // 	categoryImages.classList.add('category-images')
  //         // 	categoryTopContainer.appendChild(categoryImages)
  //         // 	otherImages.forEach((img) => {
  //         // 		const otherImageLink = img.closest('a')
  //         // 		if (otherImageLink) {
  //         // 			categoryImages.appendChild(otherImageLink)
  //         // 		} else {
  //         // 			categoryImages.appendChild(img)
  //         // 		}
  //         // 	})
  //         // 	$(categoryImages).slick({
  //         // 		slidesToShow: 1,
  //         // 		arrows: true,
  //         // 		dots: true,
  //         // 	})
  //         // }
  //       }
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // } else {
  //   categoryTopWrapper.classList.remove("has-background");
  // }
  // } else {
  //   const categoryBG = document.querySelectorAll(
  //     ".category__secondDescription > p img"
  //   );
  //   for (let img of categoryBG) {
  //     img.closest("p").remove();
  //   }
  // }
  if (subcategories) {
    // const subcategoriesImages = subcategories.querySelectorAll('.image > img')
    // subcategoriesImages.forEach((image) => {
    // 	image.src = image.src.replace('/thumb/', '/orig/')
    // // })
    // const showCategoriesBtn = document.createElement("button");
    // showCategoriesBtn.classList.add("show-categories", "btn");
    // showCategoriesBtn.innerHTML = "Subkategorie";
    // subcategories.prepend(showCategoriesBtn);
    // showCategoriesBtn.addEventListener("click", () => {
    //   subcategories.classList.toggle("show");
    // });
    const subcategoriesItems = subcategories.querySelectorAll("li");
    subcategoriesItems.forEach((item) => {
      // change https://cdn.myshoptet.com/usr/727278.myshoptet.com/user/categories/thumb/lupy-a-mikroskopy.png thumb to orig
      const img = item.querySelector("img");
      if (img.src.includes("/thumb/")) {
        img.src = img.src.replace("/thumb/", "/orig/");
      }

      if (img.dataset.src && img.dataset.src.includes("/thumb/")) {
        img.dataset.src = img.dataset.src.replace("/thumb/", "/orig/");
      }
    });
  }
  // const secondDescription = document.querySelector('.category__secondDescription')
  // if (secondDescription) {
  // 	secondDescription.id = 'dlouhy-popis'
  // 	const categoryContent = document.querySelector('#content')
  // 	categoryContent.parentElement.insertBefore(secondDescription, categoryContent.nextElementSibling)
  // }
  const categoryBanners = document.querySelectorAll(".banner-category");
  const firstProductBlock = document.querySelector("#products");
  const secondProductBlock = document.querySelector(
    ".products-block:not(#products)"
  );
  if (secondProductBlock) {
    const secondBlockProducts = secondProductBlock.querySelectorAll(".product");
    secondBlockProducts.forEach((product) => {
      if (firstProductBlock) firstProductBlock.appendChild(product);
    });
    secondProductBlock.remove();
  }
  categoryBanners.forEach((categoryBanner, index) => {
    if (categoryBanner && firstProductBlock) {
      categoryBanner.classList.add("product");
      let whereToAppend = null;
      switch (index) {
        case 0:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(7)"
          );
          break;
        case 1:
          whereToAppend = firstProductBlock.querySelector(
            ".product:nth-child(12)"
          );
          break;
      }
      if (whereToAppend) {
        whereToAppend.after(categoryBanner);
      } else {
        firstProductBlock.appendChild(categoryBanner);
      }
    }
  });
  // const productsAnchor = document.querySelector('.category-top a[href="#products"]')
  // if (productsAnchor) {
  // 	productsAnchor.addEventListener('click', (e) => {
  // 		e.preventDefault()
  // 		e.stopPropagation()
  // 		const products = document.querySelector('#products')
  // 		products.scrollIntoView({ behavior: 'smooth' })
  // 	})
  // }
  // const dlouhyPopisAnchor = document.querySelector('.category-top a[href="#dlouhy-popis"]')
  // if (dlouhyPopisAnchor) {
  // 	dlouhyPopisAnchor.addEventListener('click', (e) => {
  // 		e.preventDefault()
  // 		e.stopPropagation()
  // 		const dlouhyPopis = document.querySelector('.category__secondDescription')
  // 		dlouhyPopis.scrollIntoView({ behavior: 'smooth' })
  // 	})
  // }
  // const unveilFilters = document.querySelector('.filters-unveil-button-wrapper')
  // if (unveilFilters && window.innerWidth <= 767) categoryTop.appendChild(unveilFilters)
  // const categoryBackTop = document.querySelector('.pagination-top')
  // if (categoryBackTop) {
  // 	const categorySecondDescription = document.querySelector('.category__secondDescription')
  // 	if (categorySecondDescription) {
  // 		const buttonsWrapper = document.createElement('div')
  // 		buttonsWrapper.classList.add('buttons-wrapper', 'buttons-center')
  // 		categorySecondDescription.appendChild(buttonsWrapper)
  // 		buttonsWrapper.appendChild(categoryBackTop)
  // 	}
  // }
  // const topProducts = document.querySelector('#productsTop')
  // if (topProducts) {
  // 	const topProductsHeading = topProducts.previousElementSibling
  // 	const categoryContentMain = document.querySelector('#content')
  // 	categoryContentMain.prepend(topProducts)
  // 	categoryContentMain.prepend(topProductsHeading)
  // }

  if (window.innerWidth <= 767) {
    const subcatsFilterWrapperHelp = document.querySelector(
      ".subcategories-filter-wrapper"
    );
    if (!subcatsFilterWrapperHelp) {
      const subcatsFilterWrapper = document.createElement("div");
      subcatsFilterWrapper.classList.add("subcategories-filter-wrapper");
      const filters = document.querySelector("#filters-wrapper");
      filters.parentElement.insertBefore(subcatsFilterWrapper, filters);
      const subcategories = document.querySelector(".subcategories");
      const categoryOrdering = document.querySelector("#category-header");
      const orderTriggerHelp = document.querySelector(".order-trigger");
      // if (subcategories) subcatsFilterWrapper.appendChild(subcategories)
      if (filters) subcatsFilterWrapper.appendChild(filters);
      // if (categoryOrdering && !orderTriggerHelp) {
      //   const selectedOrder = categoryOrdering.querySelector(
      //     'input[type="radio"]:checked'
      //   );
      //   const orderTrigger = document.createElement("button");
      //   orderTrigger.classList.add("order-trigger", "btn");
      //   orderTrigger.innerHTML =
      //     "Řazení" +
      //     (selectedOrder
      //       ? `<span>(${selectedOrder.nextElementSibling.innerText})</span>`
      //       : "");
      //   subcatsFilterWrapper.appendChild(orderTrigger);
      //   orderTrigger.addEventListener("click", () => {
      //     categoryOrdering.classList.toggle("show");
      //   });
      // } else if (orderTriggerHelp)
      //   subcatsFilterWrapper.appendChild(orderTriggerHelp);
      // const filtersUnveilButton = document.querySelector(
      //   '.unveil-button[data-unveil="filters"]'
      // );
      // if (filtersUnveilButton) filtersUnveilButton.innerHTML = "Filtry";
      const productsHeader = categoryOrdering.querySelector(":scope > div");
      if (productsHeader) {
        productsHeader.classList.add("products-header");

        categoryOrdering.removeChild(productsHeader);

        subcatsFilterWrapper.parentElement.insertBefore(
          productsHeader,
          subcatsFilterWrapper
        );

        subcatsFilterWrapper.after(categoryOrdering);
      }
    }
    const products = document.querySelectorAll(".product");
    products.forEach((product) => {
      const flags = product.querySelector(".flags");
      const pInIn = product.querySelector(".p-in-in");
      if (flags && pInIn) pInIn.prepend(flags);
    });
  }
};
const handleCategoryTopBanner = () => {
  const categoryTopBanner = document.querySelector(".custom-footer__banner16 ");
  const categoryTop = document.querySelector(".category-top-wrapper");
  const categoryTopContent = categoryTop.querySelector(".category-top-content");
  if (categoryTopBanner && categoryTop) {
    categoryTopContent.before(categoryTopBanner);
  }
  if (window.innerWidth <= 767) {
    categoryTopBanner.classList.add("container");
  } else {
    categoryTopBanner.classList.remove("container");
  }
  document.addEventListener("resizeEnd", () => {
    if (window.innerWidth <= 767) {
      categoryTopBanner.classList.add("container");
    } else {
      categoryTopBanner.classList.remove("container");
    }
  });
};
if (dataLayer[0].shoptet.pageType === "category") {
  handleCategory();
  document.addEventListener("ShoptetDOMContentLoaded", () =>
    handleCategory(true)
  );
  handleCategoryTopBanner();
}

const handleProductDetail = async () => {
  const pInnerHeader = document.querySelector(".p-detail-inner-header");
  const pDetailInfo = document.querySelector(".p-detail-info");
  const pInfoWrapper = document.querySelector(".p-info-wrapper");
  const pImage = document.querySelector(".p-image-wrapper .p-image");
  const flagsDefault = document.querySelector(".product-top .flags-default");
  const pDetailInner = document.querySelector(".p-detail-inner");

  if (pInnerHeader && pDetailInfo) pInnerHeader.appendChild(pDetailInfo);
  if (pInfoWrapper && pInnerHeader) pInfoWrapper.prepend(pInnerHeader);
  if (flagsDefault && pImage) pInnerHeader.before(flagsDefault);

  const productTitle = pInnerHeader.querySelector("h1");
  if (window.innerWidth <= 903) {
    pDetailInner.prepend(productTitle);
  }
  document.addEventListener("resizeEnd", () => {
    if (window.innerWidth <= 903) {
      pDetailInner.prepend(productTitle);
    } else {
      pInnerHeader.prepend(productTitle);
    }
  });

  const pThumbnails = document.querySelector(".p-thumbnails");
  if (pThumbnails) {
    const thumbnailsTrack = pThumbnails.querySelector(
      ".p-thumbnails-inner > div"
    );
    setTimeout(() => {
      if (
        thumbnailsTrack &&
        pThumbnails.clientWidth < thumbnailsTrack.clientWidth
      ) {
        pThumbnails.classList.add("overflow-next");
      }
    }, 500);
  }

  let customAddToCart = document.querySelector(".add-to-cart-wrapper");

  if (!customAddToCart) {
    customAddToCart = document.createElement("div");
    customAddToCart.classList.add("add-to-cart-wrapper");

    const productPrices = document.querySelector(".p-final-price-wrapper");
    const productAvailability = document.querySelector(
      ".p-info-wrapper .availability-value"
    );

    if (productAvailability) {
      customAddToCart.appendChild(productAvailability);
      const availabilityLabel = productAvailability.querySelector(
        ".availability-label"
      );
      const availabilityAmount = productAvailability.querySelector(
        ".availability-amount"
      );
      if (availabilityLabel && availabilityAmount) {
        availabilityAmount.style.color = availabilityLabel.style.color;
      }
      if (productPrices) customAddToCart.appendChild(productPrices);
    }

    const productQuantity = document.querySelector(".add-to-cart .quantity");
    const addToCart = document.querySelector(".add-to-cart");

    if (productQuantity && addToCart) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("quantity-cart-wrapper");
      wrapper.appendChild(productQuantity);
      wrapper.appendChild(addToCart);
      customAddToCart.appendChild(wrapper);
    }

    const pInfoWrapper = document.querySelector(".p-info-wrapper"); 
    if (pInfoWrapper) pInfoWrapper.appendChild(customAddToCart);
    const thumbnails = document.querySelectorAll(".p-thumbnail");
    if (window.innerWidth > 767 && thumbnails.length > 1) {
      const mainImage = document.querySelector(".p-image");
      let mainImgLink = mainImage.querySelector("a").href;
      let img = mainImage.querySelector("img");

      const arrowRight = document.createElement("a");
      arrowRight.classList.add("arrow-right", "carousel-control", "right");
      arrowRight.setAttribute("role", "button");

      const arrowLeft = document.createElement("a");
      arrowLeft.classList.add("arrow-left", "carousel-control", "left");
      arrowLeft.setAttribute("role", "button");
      mainImage.append(arrowRight, arrowLeft);

      arrowRight.addEventListener("click", (e) => {
        e.preventDefault();
        arrowRight.removeAttribute("href");
        const highlighted = document.querySelector(".p-thumbnail.highlighted");

        if (highlighted) {
          const nextInLine = highlighted.nextElementSibling.nextElementSibling;
          const firstInLine = thumbnails[0];
          if (nextInLine) {
            img.src = nextInLine
              .querySelector("img")
              .src.replace("/related/", "/big/");
            // imgSrc = nextInLine.querySelector('img').src
            nextInLine.classList.add("highlighted");
          } else {
            img.src = firstInLine
              .querySelector("img")
              .src.replace("/related/", "/big/");
            firstInLine.classList.add("highlighted");
          }
          highlighted.classList.remove("highlighted");
        }
      });
      arrowLeft.addEventListener("click", () => {
        const highlighted = document.querySelector(".p-thumbnail.highlighted");
        if (highlighted) {
          const previous = highlighted.previousElementSibling;
          const lastThumb = thumbnails[thumbnails.length - 1];
          if (previous) {
            const previousInLine = previous.previousElementSibling;
            img.src = previousInLine
              .querySelector("img")
              .src.replace("/related/", "/big/");
            previousInLine.classList.add("highlighted");
          } else {
            img.src = lastThumb
              .querySelector("img")
              .src.replace("/related/", "/big/");
            lastThumb.classList.add("highlighted");
          }
          highlighted.classList.remove("highlighted");
        }
      });
    }
    if (window.innerWidth <= 767) {
      // thumbnails na mobilu přetvořené na obrázky vedle sebe se sliderem
      if (thumbnails.length) {
        let mainImage = document.querySelector(".p-image > .p-main-image"),
          productImage = document.querySelector(
            ".product-top .p-image-wrapper"
          ),
          sliderWrapper = document.createElement("div");

        sliderWrapper.classList.add("custom-slider-wrapper");
        sliderWrapper.appendChild(mainImage);

        thumbnails.forEach((thumb, index) => {
          if (index > 0) {
            let imgUrl = thumb.getAttribute("href"),
              aEl = document.createElement("a"),
              imgEl = document.createElement("img");
            aEl.classList.add("p-main-image");
            aEl.href = imgUrl;
            aEl.appendChild(imgEl);
            imgEl.src = imgUrl;
            sliderWrapper.appendChild(aEl);
          }
        });

        productImage.querySelector(".p-image").appendChild(sliderWrapper);
        // $(sliderWrapper).slick({
        //   slidesToShow: 1,
        //   arrows: true,
        //   dots: false,
        //   infinite: false,
        // });
      }
    }
  }

  const availabilityValue = document.querySelector(
    ".product-top .availability-value"
  );
  const shippingOptions = document.querySelector(
    ".product-top .shipping-options"
  );
  if (availabilityValue && shippingOptions) {
    availabilityValue.appendChild(shippingOptions);
  }

  const addToCart = document.querySelector(".add-to-cart");
  if (!addToCart) {
    document.body.classList.add("discontinued-product");
  }

  if (window.innerWidth <= 767) {
    const productTabLinks = document.querySelector(".responsive-nav");
    // if (productTabLinks) {
    //   const tabsTrigger = document.createElement("button");
    //   tabsTrigger.classList.add("tabs-trigger");
    //   const tabsLength = productTabLinks.querySelectorAll(".shp-tab").length;
    //   const activeTabText =
    //     productTabLinks.querySelector(".shp-tab.active").innerText;
    //   tabsTrigger.innerHTML =
    //     activeTabText +
    //     " <span>(" +
    //     tabsLength +
    //     " " +
    //     (tabsLength <= 1
    //       ? "záložka"
    //       : tabsLength >= 5
    //       ? "záložek"
    //       : "záložky") +
    //     ")</span>";
    //   productTabLinks.parentElement.prepend(tabsTrigger);
    //   tabsTrigger.addEventListener("click", () => {
    //     productTabLinks.classList.toggle("show");
    //   });

    //   const elToWatch = productTabLinks.querySelector(".shp-tabs");
    //   const observerCallback = (mutationsList, observer) => {
    //     for (const mutation of mutationsList) {
    //       if (
    //         mutation.type === "attributes" &&
    //         mutation.attributeName === "class"
    //       ) {
    //         if (mutation.target.classList.contains("active")) {
    //           const activeTabText =
    //             productTabLinks.querySelector(".shp-tab.active").innerText;
    //           tabsTrigger.innerHTML =
    //             activeTabText +
    //             " <span>(" +
    //             tabsLength +
    //             " " +
    //             (tabsLength <= 1
    //               ? "záložka"
    //               : tabsLength >= 5
    //               ? "záložek"
    //               : "záložky") +
    //             ")</span>";
    //         }
    //       }
    //     }
    //   };

    //   const observer = new MutationObserver(observerCallback);
    //   const observerOptions = {
    //     attributes: true,
    //     subtree: true,
    //     attributeFilter: ["class"],
    //   };
    //   observer.observe(elToWatch, observerOptions);
    // }
  }
  window.waitFor("#dkLabFavouriteDiv").then(() => {
    const dkLabFavoutideDiv = document.querySelector("#dkLabFavouriteDiv");
    if (addToCart) addToCart.prepend(dkLabFavoutideDiv);
  });

  const readDescription = document.querySelector(
    ".product-top a.chevron-down-after"
  );
  if (readDescription) {
    readDescription.removeAttribute("data-toggle");
    readDescription.removeAttribute("data-force-scroll");
  }

  const socialButtons = document.querySelector(".social-buttons");
  const socialButtonsClose = document.querySelector(
    ".social-buttons .close-wrapper"
  );
  if (socialButtons) {
    const copyLinkBtn = document.createElement("div");
    copyLinkBtn.classList.add("copy-link", "btn");
    copyLinkBtn.innerHTML = "Kopírovat odkaz";
    copyLinkBtn.addEventListener("click", () => {
      const linkToCopy = window.location.href;
      navigator.clipboard.writeText(linkToCopy);
      copyLinkBtn.innerHTML = "Odkaz zkopírován";
    });
    if (socialButtonsClose) socialButtonsClose.before(copyLinkBtn);
    else socialButtons.appendChild(copyLinkBtn);
  }
  document.querySelectorAll(".variant-name-wrapper").forEach((wrapper) => {
    const nameDiv = wrapper.querySelector(".variant-name");
    if (!nameDiv) return;
    console.log(nameDiv);
    nameDiv.textContent = nameDiv.textContent
      .trim()
      .replace(/^Varianta:\s*/, "");

    const parentDiv = nameDiv.parentElement;
    const spans = Array.from(parentDiv.querySelectorAll(" span"));
    spans.forEach((span) => {
      nameDiv.parentElement.insertAdjacentElement("afterend", span);
    });

    parentDiv.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes("|")) {
        node.textContent = node.textContent.replace(/\|\s*/, "");
      }
    });
  });
  const isPriceOnDemand =
    dataLayer[0].shoptet.product.priceWithVat === 0.01 ? true : false;
  if (isPriceOnDemand) {
    document.body.classList.add("price-on-demand");
    handleOnDemandProducts();
  }
};
if (dataLayer[0].shoptet.pageType === "productDetail") {
  handleProductDetail();

  const variantTable = document.querySelector(".variant-table");
  const hasVariants =
    variantTable?.querySelectorAll(".variant-submit").length > 0;

  const existingButton = document.querySelector(".summary-add-to-cart");

  if (hasVariants && !existingButton) {
    const summaryButton = document.createElement("button");
    summaryButton.textContent = "Souhrnně přidat do košíku";
    summaryButton.classList.add("summary-add-to-cart", "btn", "btn-secondary");
    summaryButton.style.fontFamily = "inherit";

    variantTable.after(summaryButton);

    summaryButton.addEventListener("click", () => {
      const variantRows = variantTable.querySelectorAll(".variant-submit");

      variantRows.forEach((row) => {
        const input = row.querySelector('input[type="number"]');
        const button = row.querySelector(".add-to-cart-button");

        if (!input || !button) return;

        const qty = parseInt(input.value, 10);

        if (qty > 0) {
          button.click();
        }
      });
    });
  }
}

function handleOnDemandProducts() {
  if (!document.body.classList.contains("price-on-demand")) return;

  const pFinalPriceWrapper = document.querySelector(".p-final-price-wrapper");
  if (pFinalPriceWrapper) {
    pFinalPriceWrapper.innerHTML =
      "<strong class='price-final'>Cena na dotaz</strong>";
  }

  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  if (!addToCartWrapper) return;
  const quantityCartWrapper = addToCartWrapper.querySelector(
    ".quantity-cart-wrapper"
  );
  if (quantityCartWrapper) {
    quantityCartWrapper.style.display = "none";
  }
  const originalLinks = document.querySelector(".link-icons.watchdog-active");
  if (!originalLinks || !addToCartWrapper) return;

  if (addToCartWrapper.querySelector(".contact-product")) return;

  const clonedLinks = originalLinks.cloneNode(true);

  const askLink = clonedLinks.querySelector(".link-icon.chat");
  if (askLink) {
    let currentPath = window.location.pathname.replace(/\/$/, "");
    askLink.href = `${currentPath}:dotaz`;
    askLink.querySelector("span").textContent = "Kontaktovat prodejce";
    askLink.classList.add("contact-product", "btn", "btn-primary");
  }

  clonedLinks.querySelectorAll("a").forEach((link) => {
    if (!link.classList.contains("contact-product"))
      link.style.display = "none";
  });

  addToCartWrapper.appendChild(clonedLinks);
}

function getScrollbarWidth() {
  const div = document.createElement("div");

  // Nastavení stylu divu
  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.visibility = "hidden";

  // Přidání divu do těla dokumentu
  document.body.appendChild(div);

  // Výpočet šířky scrollbaru
  const scrollbarWidth = div.offsetWidth - div.clientWidth;

  // Odebrání divu z těla dokumentu
  document.body.removeChild(div);

  // Vrácení šířky scrollbaru
  return scrollbarWidth;
}

document.documentElement.style.setProperty(
  "--scrollbar-width",
  `${getScrollbarWidth()}px`
);

const handleLastVisited = () => {
  // NAPOSLEDY PROHLIZENE
  const contentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.classList && node.querySelector(".dkLabVisitedProductsBox")) {
          const whereToAppend = document.querySelector(
            ".homepage-box.welcome-wrapper"
          );
          if (whereToAppend) {
            whereToAppend.parentElement.insertBefore(node, whereToAppend);
          }
          contentObserver.disconnect();
        }
      });
    });
  });
  const indexContent = document.querySelector(".overall-wrapper");
  if (indexContent) contentObserver.observe(indexContent, { childList: true });
};
const handleFooterBanners = () => {
  const footerBanners = document.querySelector(".footer-banners");
  const carouselBanner = document.querySelector("#carousel");
  if (footerBanners && carouselBanner)
    carouselBanner.parentElement.insertBefore(
      footerBanners,
      carouselBanner.nextElementSibling
    );
};
if (dataLayer[0].shoptet.pageType === "homepage") {
  handleFooterBanners();
  // handleLastVisited()
}

function handleLogo() {
  const logoImg = document.querySelector(".site-name-wrapper img");
  if (!logoImg) return;
  logoImg.src =
    window.innerWidth <= 767
      ? "/user/documents/upload/miranda/logo-mobile.png"
      : "https://cdn.myshoptet.com/usr/727278.myshoptet.com/user/logos/logo.svg";
}
handleLogo();
window.addEventListener("resize", handleLogo);
